import React, { useState, useEffect } from "react";
import { Typography, FormControl, TextField } from "@mui/material";
import moment from "moment";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import { updateProfile, hideError } from "../../redux/action";
import { allowedIdType } from "../../../utils/allowedIdType";
import { StepLabel, CustomButton, DefaultLoader } from "../../../components";
import styles from "../styles";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";
const REQUIRED = "REQUIRED";

const UpdateAddress = props => {
  const { loading, profile, updateProfile, history } = props;

  const [address1, setAddress1] = useState({ value: "", error: false });
  const [address2, setAddress2] = useState({ value: "", error: false });
  const [address3, setAddress3] = useState({ value: "", error: false });
  const [btnDisabled, setBtnDisabled] = useState(false);

  const localIdentity = profile?.identities?.find(allowedIdType);


  const checkAddressLine = (value, line) => {
    let addressLine = "";
    if (value.contacts) {
      if (
        value.contacts.find(contact => contact.contactTypeCd === "PERMANENT")[
          line
        ]
      ) {
        addressLine = value.contacts
          .find(contact => contact.contactTypeCd === "PERMANENT")
          [line].slice(0, 40);
      }
    }
    return addressLine;
  };

  useEffect(() => {
    if (profile) {
      setAddress1({ ...address1, value: checkAddressLine(profile, "line1") });
      setAddress2({ ...address2, value: checkAddressLine(profile, "line2") });
      setAddress3({ ...address3, value: checkAddressLine(profile, "line3") });
    }
  }, [profile]);

  const handleUpdate = () => {
    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: address1.value, //R
        line2: address2.value,
        line3: address3.value,
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R
        city: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city, //R
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship, //R
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    updateProfile({ payloadData: payload, from: PROFILE });
  };

  const checkIsHaveAnError = () => {
    if (address1.value.length === 0 || address1.error) return true;
    if (address2.error) return true;
    if (address3.error) return true;
    return false;
  };

  useEffect(() => {
    setBtnDisabled(checkIsHaveAnError());
  }, [address1, address2, address3]);

  const addressLineSetupErr = (value, isValid, required) => {
    if (required) return !isValid;
    return !isValid && value.length > 0;
  };

  const handleChange = (field, e, required) => {
    const value = e.target.value;
    const format = /^[a-zA-Z0-9\x20,.\-\/&#!@$%^*~+]{1,40}$/;
    const isValid = format.test(value);
    field(prevState => ({
      ...prevState,
      value: value,
      error: addressLineSetupErr(value, isValid, required),
    }));
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}

      <StepLabel
        title="Update address"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <Typography
            color="textPrimary"
            style={{ ...styles.baseFont, ...styles.inputLabel }}
          >
            Address*
          </Typography>
          <TextField
            placeholder="Line 1 (Required)"
            variant="outlined"
            fullWidth
            value={address1.value}
            error={address1.error}
            helperText={address1.error && "Invalid address format"}
            onChange={e => handleChange(setAddress1, e, REQUIRED)}
            inputProps={{
              style: { ...styles.baseFont, padding: "12px 16px" },
              maxLength: 40,
            }}
          />
        </FormControl>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <TextField
            placeholder="Line 2 (Optional)"
            variant="outlined"
            fullWidth
            value={address2.value}
            error={address2.error && address2.value.length > 0}
            helperText={
              address2.error &&
              address2.value.length > 0 &&
              "Invalid address format"
            }
            onChange={e => handleChange(setAddress2, e)}
            inputProps={{
              style: { ...styles.baseFont, padding: "12px 16px" },
              maxLength: 40,
            }}
          />
        </FormControl>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <TextField
            placeholder="Line 3 (Optional)"
            variant="outlined"
            fullWidth
            value={address3.value}
            error={address3.error && address3.value.length > 0}
            helperText={
              address3.error &&
              address3.value.length > 0 &&
              "Invalid address format"
            }
            onChange={e => handleChange(setAddress3, e)}
            inputProps={{
              style: { ...styles.baseFont, padding: "12px 16px" },
              maxLength: 40,
            }}
          />
        </FormControl>
      </form>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={btnDisabled}
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
  }),
  {
    updateProfile,
    hideError,
  }
);

export default compose(
  withRouter,
  withConnect
)(UpdateAddress);
